export enum AmplitudeNipRequestType {
  CREDIT_HISTORY = 'credit_history',
  EVALUATION = 'evaluation',
}
